import React from "react";
import { MdNewReleases } from "react-icons/md";
import { TextIconButton } from "./TextIconButton";

interface WhatsNewButtonProps {
  isScrollHidden?: boolean;
  topButtonsExpanded?: boolean;
  isSmallScreen?: boolean;
  onClick: () => void;
}

export function WhatsNewButton({
  isScrollHidden = false,
  topButtonsExpanded = false,
  isSmallScreen = false,
  onClick,
}: WhatsNewButtonProps) {
  return (
    <>
      <style>
        {`
          .whatsnew-button span {
            font-size: ${isSmallScreen ? "10px" : "12px"} !important;
          }
        `}
      </style>
      <TextIconButton
        icon={MdNewReleases({ size: isSmallScreen ? 14 : 20 })}
        text="What's New"
        onClick={onClick}
        className="whatsnew-button"
        showText={topButtonsExpanded}
        tooltipText="What's New"
        isScrollHidden={isScrollHidden}
      />
    </>
  );
}
